$(document).ready(function () {
  if ($(window).width() < 768) {
    $(".shopify-section-group-header-group .multi-column__grid").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
      dots: false,
      adaptiveHeight: true,
    });
  }
});
